// extracted by mini-css-extract-plugin
module.exports = {"drawerMenu":"style_drawerMenu__3gIu6"};